<!--Overrides @basecom-gmbh/pond/components/cms/element/CmsElementProductListing.vue-->
<script setup lang="ts">
const props = defineProps<{
    element: CmsElementProductListing;
}>();
const route = useRoute();
const { trackSelectItem } = useAnalytics();
const { getElements, search, getCurrentListing, loading } = useCategoryListing();
// TODO create a better ID based on the CmsPage or even better CmsSlot identifier
const productListingCriteriaStore = useProductListingCriteriaStore('category');
const { criteria, total, page, limit } = storeToRefs(productListingCriteriaStore);
// I just commented that out, needs further checks but the cals below made multiple unnessesary calls to ther products endpoint
//const productListingStore = useProductListingStore();

productListingCriteriaStore.initializeCriteria(
    {
        limit: props.element.data.listing.limit,
        p: props.element.data.listing.page,
        associations: {
            children: {},
            manufacturer: {},
            options: {},
            media: {},
            properties: {
                associations: {
                    group: {},
                },
            },
        },
    },
    route.query,
);

const { y: windowYPosition } = useScroll(window, { behavior: 'smooth' });

const changePage = async (page: number) => {
    windowYPosition.value = 0;
    productListingCriteriaStore.setPage(page);

    await search(criteria.value);
    productListingCriteriaStore.setSearchResult(getCurrentListing.value);
    //CUSTOM IDS-95: grabbed listing in order to get product properties name.
    //  productListingStore.setListing(getCurrentListing.value);
};

const config = useCmsElementConfig(props.element);
const boxLayout = config.getConfigValue('boxLayout');
await search(criteria.value);
productListingCriteriaStore.setSearchResult(getCurrentListing.value, true);

//CUSTOM IDS-95: grabbed listing in order to get product properties name.
//productListingStore.setListing(getCurrentListing.value);
</script>

<template>
    <div v-if="getElements.length > 0">
        <!-- IDS-36 - Adjust styles and add skeleton loading-->
        <div
            class="grid grid-cols-1 justify-items-center gap-x-8 gap-y-11 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
        >
            <template v-if="loading">
                <ProductCardSkeleton
                    v-for="i in 12"
                    :key="i"
                />
            </template>
            <template v-else>
                <template
                    v-for="product in getElements"
                    :key="product.id"
                >
                    <ProductCard
                        :product="product"
                        :layout="boxLayout"
                        displayMode="contain"
                        @select-product="trackSelectItem(product)"
                    />
                </template>
            </template>
        </div>

        <LayoutPagination
            :total="total ?? 0"
            :items-per-page="limit"
            :default-page="page"
            @update-page="currentPage => changePage(currentPage)"
        />
    </div>

    <div
        v-else
        class="flex flex-col items-center justify-center py-32"
    >
        <img
            src="/assets/icons/ids_empty_plp.svg"
            :alt="$t('cms.emptyPlp')"
        />
        <span class="non-italic text-lg font-extrabold leading-6">{{
            $t('cms.element.product.noProductsAvailable')
        }}</span>
    </div>
</template>
